/**
 * Checks if an object has a specific property.
 * @param {object} obj - The haystack object.
 * @param {string} prop - The needle.
 * @returns {boolean}
 */
function hasProp (obj, prop) {
  return obj !== undefined && obj !== null && Object.prototype.hasOwnProperty.call(obj, prop)
}
/**
 * Checks that an object isn't empty.
 * @param {object} obj
 * @returns {boolean}
 */
function notEmptyObject (obj) {
  return (isObject(obj) && Object.keys(obj).length > 0)
}
/**
   * Checks if a variable is an object or not.
   * @param {*} x - The variable to check.
   * @returns {boolean}
   */
function isObject (x) {
  return x !== undefined && x !== null && typeof x === 'object'
}
/**
   * Checks if the variable is an array or not.
   * @param {*} x
   * @returns {boolean}
   */
function isArray (x) {
  return x !== undefined && x !== null && Array.isArray(x)
}
/**
   * Checks if the variable is empty.
   * @param {*} x
   * @returns {boolean}
   */

function isEmpty (x) {
  if (x === undefined || x === null) {
    return true
  } else if (isArray(x)) {
    return (x.length === 0)
  } else if (isObject(x)) {
    return !notEmptyObject(x)
  } else {
    return (x.toString().length === 0)
  }
}
/**
   * Returns the size of the variable.
   * @memberof Utils
   * @param {*} x
   * @returns {number}
   */
function size (x) {
  if (isEmpty(x)) {
    return 0
  } else if (isArray(x)) {
    return Object.keys(x).length
  } else if (isObject(x)) {
    return Object.keys(x).length
  } else {
    return x.toString().length
  }
}

function generateRandomString () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)

      return v.toString(16)
    })
}

module.exports = {
  hasProp,
  notEmptyObject,
  isObject,
  isArray,
  isEmpty,
  size,
  generateRandomString
}
